import React, { useEffect } from "react";
export const KotInvoicePrint = ({ dependencies }) => {
  const { renderCycleID: id } = dependencies;
  useEffect(
    () => id && sessionStorage.setItem("kot-print-render-cycle-id", id),
    [id]
  );
  if (!dependencies) return "";

  const {
    user_title,
    order_json,
    paymentMode,
    categoryDetails,
    kot_setup,
    kotNumber,
    section_name,
    seat_name,
    itemsDetails,
    dateFormat,
  } = dependencies;

  const seat = kot_setup?.kot_field_customization?.seat;
  const ticket_number = kot_setup?.kot_field_customization?.ticket_number;
  const order_number = kot_setup?.kot_field_customization?.order_number;
  const payment_mode = kot_setup?.kot_field_customization?.payment_mode;
  const cashier = kot_setup?.kot_field_customization?.cashier;
  const date = kot_setup?.kot_field_customization?.date;
  const time = kot_setup?.kot_field_customization?.time;
  const serial_number_in_items =
    kot_setup?.kot_field_customization?.serial_number_in_items;
  const total_item_quantity =
    kot_setup?.kot_field_customization?.total_item_quantity;
  const headerValues = kot_setup?.kot_field_customization;
  const category_name = kot_setup?.kot_field_customization?.category_name;
  const item_amount = kot_setup?.kot_field_customization?.item_amount;
  const kotItemDetails = order_json?.order_kot_details?.find(
    (kot) => +kot.kot === +kotNumber
  )?.kot_items_details;
  const kotItemPrice = order_json?.order_kot_details?.find(
    (kot) => +kot.kot === +kotNumber
  )?.kot_total;
  const orderDate = new Date(+order_json?.created_at || order_json?.created_at);

  return (
    <>
      <table style={{ width: "100%", borderBottom: "1px solid black" }}>
        <tr>
          <td style={{ textAlign: "center" }}>KOT</td>
        </tr>
        <tr>
          <td
            style={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "x-large",
            }}
            id="kot-print-heading"
          ></td>
        </tr>
      </table>
      <div>
        {+seat === 1 && (
          <div
            style={{
              float: "left",
              width: "60%",
              fontSize: "large",
            }}
          >
            At:{" "}
            {+order_json?.order_type === 1
              ? "Take Away"
              : +order_json?.order_type === 2
              ? "Delivery"
              : +order_json?.order_type === 3
              ? "Zomato"
              : +order_json?.order_type === 4
              ? "Swiggy"
              : +order_json?.order_type === 5
              ? "Meals"
              : `${seat_name} - ${section_name}`}
          </div>
        )}
        {+ticket_number === 1 && (
          <div
            style={{
              float: "left",
              width: "40%",
              fontSize: "large",
            }}
          >
            KOT: [{kotNumber}]
          </div>
        )}
        {+order_number === 1 && (
          <div
            style={{
              float: "left",
              width: "60%",
              fontSize: "large",
            }}
          >
            Order No. : {order_json?.local_order_id}
          </div>
        )}
        {(+payment_mode === 1 || +cashier === 1) && (
          <div
            style={{
              float: "right",
              width: "40%",
              fontSize: "large",
            }}
          >
            Payment :{" "}
            {order_json?.payment_status !== 0
              ? +cashier === 1 && user_title
              : "Unpaid"}
            {+payment_mode === 1 &&
              +cashier === 1 &&
              +order_json?.payment_status !== 0 &&
              " - "}
            {+payment_mode === 1 && +order_json?.payment_status !== 0
              ? +order_json?.payment_details?.length === 1
                ? paymentMode?.filter(
                    (item) =>
                      item.payment_mode_uuid ===
                      order_json?.payment_details[0].payment_mode_uuid
                  )[0]?.payment_mode_name
                : "Multi"
              : ""}
          </div>
        )}

        {(+date === 1 || +time === 1) && (
          <div
            style={{
              float: "left",
              width: "60%",
              fontSize: "large",
            }}
          >
            {+date === 1 &&
              order_json &&
              dateFormat
                ?.replace(
                  "mm",
                  ("00" + (orderDate?.getMonth() + 1).toString()).slice(-2)
                )
                ?.replace(
                  "yy",
                  ("0000" + orderDate?.getFullYear().toString()).slice(-4)
                )
                .replace(
                  "dd",
                  ("00" + orderDate?.getDate().toString()).slice(-2)
                )}
            {+date === 1 && +time === 1 && "-"}
            {time &&
              ("00" + orderDate?.getHours().toString()).slice(-2) +
                ":" +
                ("00" + orderDate?.getMinutes().toString()).slice(-2)}
          </div>
        )}
      </div>
      <table
        style={{
          width: "100%",
          borderTop: "1px solid black",
          borderBottom: "1px solid black",
        }}
      >
        <tr>
          {+serial_number_in_items === 1 && (
            <th
              style={{
                fontSize: "large",
                fontWeight: "bold",
                textAlign: "left",
                borderBottom: "1px dotted black",
                width: "10%",
              }}
            >
              S.No
            </th>
          )}
          <th
            style={{
              fontSize: "large",
              fontWeight: "bold",
              borderBottom: "1px dotted black",
              textAlign: "left",
            }}
            colSpan={2}
          >
            Items
          </th>
          {category_name === 1 ? (
            <th
              style={{
                fontSize: "large",
                fontWeight: "bold",
                borderBottom: "1px dotted black",
                textAlign: "left",
              }}
            >
              Category
            </th>
          ) : (
            ""
          )}
          <th
            style={{
              fontSize: "large",
              fontWeight: "bold",
              borderBottom: "1px dotted black",
              textAlign: "left",
            }}
          >
            Qty
          </th>
          {item_amount === 1 ? (
            <th
              style={{
                fontSize: "large",
                fontWeight: "bold",
                borderBottom: "1px dotted black",
                textAlign: "left",
              }}
            >
              Amt
            </th>
          ) : (
            ""
          )}
        </tr>
        {kotItemDetails?.map((data, ci) => (
          <tr
            style={
              data.order_item_status === 2
                ? {
                    textDecoration: "line-through",
                    fontSize: "large",
                    display: "none",
                  }
                : { fontSize: "large" }
            }
            className="kot_print_items"
            id={`kot_print_item:${data.item_uuid}`}
          >
            {+serial_number_in_items === 1 && (
              <td
                style={{
                  fontSize: "large",
                  textAlign: "left",
                  width: "10%",
                }}
              >
                #{ci + 1}
              </td>
            )}
            <td colSpan={2}>
              {(data?.parcel === "Y" ? "[Parcel] " : "") +
                (itemsDetails?.find(
                  (itemdata) => itemdata.item_uuid === data.item_uuid
                )
                  ? itemsDetails?.find(
                      (itemdata) => itemdata.item_uuid === data.item_uuid
                    ).outlet_wise_item_details[0].other_details.item_kot_name
                    ? itemsDetails?.find(
                        (itemdata) => itemdata.item_uuid === data.item_uuid
                      ).outlet_wise_item_details[0].other_details.item_kot_name
                    : itemsDetails?.find(
                        (itemdata) => itemdata.item_uuid === data.item_uuid
                      ).item_name
                  : "")}
              {data?.order_item_instruction ? (
                <>
                  <br />
                  {`[${data.order_item_instruction}]`}
                </>
              ) : (
                ""
              )}
              {data?.addon_details?.map((addonDetails) => (
                <i>
                  <br />-
                  {itemsDetails?.find(
                    (itemdata) => itemdata.item_uuid === addonDetails.item_uuid
                  ) &&
                    itemsDetails?.find(
                      (itemdata) =>
                        itemdata.item_uuid === addonDetails.item_uuid
                    ).item_name}
                </i>
              ))}
              {data?.multi_details?.map((MultiDetails) => (
                <i>
                  <br />+{MultiDetails.name}
                </i>
              ))}
            </td>
            {category_name === 1 ? (
              <td>
                {
                  categoryDetails.find(
                    (itemCategory) =>
                      itemsDetails?.find(
                        (itemdata) => itemdata.item_uuid === data.item_uuid
                      )?.category_uuid === itemCategory.category_uuid
                  ).category_name
                }
              </td>
            ) : (
              ""
            )}
            <td style={{ fontSize: "large" }}>{data.order_item_qty}</td>
            {item_amount === 1 ? (
              <td style={{ fontSize: "large" }}>
                {data.order_item_qty * data?.order_item_unit_price}
                {data?.addon_details?.map((MultiDetails) => (
                  <>
                    <br />
                    {data.order_item_qty * MultiDetails.price}
                  </>
                ))}
                {data?.multi_details?.map((MultiDetails) => (
                  <>
                    <br />
                    {data.order_item_qty * MultiDetails.price}
                  </>
                ))}
              </td>
            ) : (
              ""
            )}
          </tr>
        ))}
      </table>
      <table style={{ width: "100%", borderBottom: "1px solid black" }}>
        <tr>
          <td style={{ width: "50%" }}>
            <table style={{ width: "100%" }}>
              <tr>
                <td style={{ width: "40%", fontSize: "large" }}>
                  {(+order_json?.order_type === 0 &&
                  ((+headerValues?.customer_name_dinein === 1 &&
                    order_json?.customer_name !== "") ||
                    (+headerValues?.customer_mobile_dinein === 1 &&
                      order_json?.customer_mobile !== "") ||
                    (+headerValues?.customer_address_dinein === 1 &&
                      order_json?.delivery_address !== ""))
                    ? "For: "
                    : +order_json?.order_type === 0 &&
                      ((+headerValues?.customer_name_takeaway === 1 &&
                        order_json?.customer_name !== "") ||
                        (+headerValues?.customer_mobile_takeaway === 1 &&
                          order_json?.customer_mobile !== "") ||
                        (+headerValues?.customer_address_takeaway === 1 &&
                          order_json?.delivery_address !== ""))
                    ? "For: "
                    : +order_json?.order_type === 0 &&
                      ((+headerValues?.customer_name_delivery === 1 &&
                        order_json?.customer_name !== "") ||
                        (+headerValues?.customer_mobile_delivery === 1 &&
                          order_json?.customer_mobile !== "") ||
                        (+headerValues?.customer_address_delivery === 1 &&
                          order_json?.delivery_address !== ""))
                    ? "For: "
                    : +order_json?.order_type === 0 &&
                      ((+headerValues?.customer_name_zomato === 1 &&
                        order_json?.customer_name !== "") ||
                        (+headerValues?.customer_mobile_zomato === 1 &&
                          order_json?.customer_mobile !== "") ||
                        (+headerValues?.customer_address_zomato === 1 &&
                          order_json?.delivery_address !== ""))
                    ? "For: "
                    : +order_json?.order_type === 0 &&
                      ((+headerValues?.customer_name_swiggy === 1 &&
                        order_json?.customer_name !== "") ||
                        (+headerValues?.customer_mobile_swiggy === 1 &&
                          order_json?.customer_mobile !== "") ||
                        (+headerValues?.customer_address_swiggy === 1 &&
                          order_json?.delivery_address !== ""))
                    ? "For: "
                    : +order_json?.order_type === 0 &&
                      ((+headerValues?.customer_name_meals === 1 &&
                        order_json?.customer_name !== "") ||
                        (+headerValues?.customer_mobile_meals === 1 &&
                          order_json?.customer_mobile !== "") ||
                        (+headerValues?.customer_address_meals === 1 &&
                          order_json?.delivery_address !== ""))
                    ? "For: "
                    : "") +
                    (+order_json?.order_type === 1
                      ? +headerValues?.customer_name_takeaway === 1
                        ? order_json?.customer_name
                        : ""
                      : +order_json?.order_type === 2
                      ? +headerValues?.customer_name_delivery === 1
                        ? order_json?.customer_name
                        : " "
                      : +order_json?.order_type === 3
                      ? +headerValues?.customer_name_zomato === 1
                        ? order_json?.customer_name
                        : " "
                      : +order_json?.order_type === 4
                      ? +headerValues?.customer_name_swiggy === 1
                        ? order_json?.customer_name
                        : " "
                      : +order_json?.order_type === 5
                      ? +headerValues?.customer_name_meals === 1
                        ? order_json?.customer_name
                        : " "
                      : +order_json?.order_type === 0
                      ? +headerValues?.customer_name_dinein === 1
                        ? order_json?.customer_name
                        : " "
                      : "") +
                    (+order_json?.order_type === 1
                      ? +headerValues?.customer_mobile_takeaway === 1
                        ? (+headerValues?.customer_name_takeaway === 1 &&
                          order_json?.customer_name !== "" &&
                          order_json?.customer_mobile !== ""
                            ? " - "
                            : " ") + order_json?.customer_mobile
                        : " "
                      : +order_json?.order_type === 2
                      ? +headerValues?.customer_mobile_delivery === 1
                        ? (+headerValues?.customer_name_delivery === 1 &&
                          order_json?.customer_name !== "" &&
                          order_json?.customer_mobile !== ""
                            ? " - "
                            : " ") + order_json?.customer_mobile
                        : " "
                      : +order_json?.order_type === 3
                      ? +headerValues?.customer_mobile_zomato === 1
                        ? (+headerValues?.customer_name_zomato === 1 &&
                          order_json?.customer_name !== "" &&
                          order_json?.customer_mobile !== ""
                            ? " - "
                            : " ") + order_json?.customer_mobile
                        : " "
                      : +order_json?.order_type === 4
                      ? +headerValues?.customer_mobile_swiggy === 1
                        ? (+headerValues?.customer_name_swiggy === 1 &&
                          order_json?.customer_name !== "" &&
                          order_json?.customer_mobile !== ""
                            ? " - "
                            : " ") + order_json?.customer_mobile
                        : " "
                      : +order_json?.order_type === 5
                      ? +headerValues?.customer_mobile_meals === 1
                        ? (+headerValues?.customer_name_meals === 1 &&
                          order_json?.customer_name !== "" &&
                          order_json?.customer_mobile !== ""
                            ? " - "
                            : " ") + order_json?.customer_mobile
                        : " "
                      : +order_json?.order_type === 0
                      ? +headerValues?.customer_mobile_dinein === 1
                        ? (+headerValues?.customer_name_dinein === 1 &&
                          order_json?.customer_name !== "" &&
                          order_json?.customer_mobile !== ""
                            ? " - "
                            : " ") + order_json?.customer_mobile
                        : " "
                      : "")}
                </td>
              </tr>
              <tr>
                <td style={{ width: "40%", fontSize: "large" }}>
                  {+order_json?.order_type === 1
                    ? +headerValues?.customer_address_takeaway === 1 &&
                      order_json?.delivery_address
                    : +order_json?.order_type === 2
                    ? +headerValues?.customer_address_delivery === 1 &&
                      order_json?.delivery_address
                    : +order_json?.order_type === 3
                    ? +headerValues?.customer_address_zomato === 1 &&
                      order_json?.delivery_address
                    : +order_json?.order_type === 4
                    ? +headerValues?.customer_address_swiggy === 1 &&
                      order_json?.delivery_address
                    : +order_json?.order_type === 5
                    ? +headerValues?.customer_address_meals === 1 &&
                      order_json?.delivery_address
                    : +order_json?.order_type === 0
                    ? +headerValues?.customer_address_dinein === 1 &&
                      order_json?.delivery_address
                    : ""}
                </td>
              </tr>

              <tr>
                <td style={{ fontSize: "large", fontWeight: "bold" }}>
                  {total_item_quantity === 1
                    ? "Total Qty : " +
                      (Array.isArray(kotItemDetails) &&
                      kotItemDetails?.map((a) => a.order_item_qty).length > 1
                        ? kotItemDetails
                            ?.map((a) => a.order_item_qty)
                            .reduce((a, b) => a + b)
                        : Array.isArray(kotItemDetails) &&
                          kotItemDetails[0]?.order_item_qty)
                    : ""}
                </td>
              </tr>
            </table>
          </td>
          <td style={{ width: "50%" }}>
            <table style={{ width: "100%" }}>
              {item_amount === 1 ? (
                <tr>
                  <td style={{ fontSize: "large", fontWeight: "bold" }}>
                    Kot Total:
                  </td>
                  <td style={{ fontSize: "large", fontWeight: "bold" }}>
                    {kotItemPrice}
                  </td>
                </tr>
              ) : (
                ""
              )}
            </table>
          </td>
        </tr>
      </table>
    </>
  );
};
